module.exports = __webpack_public_path__ + "media/images/common/menu_close_icon-7004d47833bd10974bc94b743824ba60.png";